import { Stack } from "@mui/material";
import { StyledIconButton } from "./icon-links.styles";
import { links } from "./icon-links.const";

export const IconLinks = () => {
  return (
    <Stack spacing={2} direction='row'>
      {links.map((link) => {
        return (
          <StyledIconButton
            key={link.ariaLabel}
            aria-label={link.ariaLabel}
            component='a'
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.icon}
          </StyledIconButton>
        );
      })}
    </Stack>
  );
};
